// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Decco from "decco/src/Decco.bs.mjs";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Js_array from "rescript/lib/es6/js_array.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as User$FeedSync from "./models/User.bs.mjs";

function feed_encode(v) {
  switch (v.TAG | 0) {
    case /* XMLFeed */0 :
        return [
                "XMLFeed",
                Decco.stringToJson(v._0)
              ];
    case /* CSVFeed */1 :
        return [
                "CSVFeed",
                Decco.stringToJson(v._0)
              ];
    case /* TSVFeed */2 :
        return [
                "TSVFeed",
                Decco.stringToJson(v._0)
              ];
    case /* CSVFeedNoQuotes */3 :
        return [
                "CSVFeedNoQuotes",
                Decco.stringToJson(v._0)
              ];
    case /* TSVFeedNoQuotes */4 :
        return [
                "TSVFeedNoQuotes",
                Decco.stringToJson(v._0)
              ];
    
  }
}

function feed_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = Js_array.map(Js_json.classify, jsonArr$1);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "CSVFeed" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CSVFeed */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "CSVFeedNoQuotes" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CSVFeedNoQuotes */3,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "TSVFeed" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TSVFeed */2,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "TSVFeedNoQuotes" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TSVFeedNoQuotes */4,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "XMLFeed" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* XMLFeed */0,
                      _0: v0$4._0
                    }
                  };
          }
          var e$4 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function autoSync_encode(v) {
  switch (v) {
    case /* Disabled */0 :
        return ["Disabled"];
    case /* Hourly */1 :
        return ["Hourly"];
    case /* SixHours */2 :
        return ["SixHours"];
    case /* TwelveHours */3 :
        return ["TwelveHours"];
    
  }
}

function autoSync_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = Js_array.map(Js_json.classify, jsonArr$1);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Disabled" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Disabled */0
                  };
          }
      case "Hourly" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Hourly */1
                  };
          }
      case "SixHours" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* SixHours */2
                  };
          }
      case "TwelveHours" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* TwelveHours */3
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "userId",
                Curry._1(User$FeedSync.Id.t_encode, v.userId)
              ],
              [
                "supplementaryFeed",
                Decco.optionToJson(feed_encode, v.supplementaryFeed)
              ],
              [
                "currencies",
                Decco.arrayToJson((function (param) {
                        return [
                                Decco.stringToJson(param[0]),
                                feed_encode(param[1])
                              ];
                      }), v.currencies)
              ],
              [
                "autoSync",
                autoSync_encode(v.autoSync)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var userId = Curry._1(User$FeedSync.Id.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "userId"), null));
  if (userId.TAG === /* Ok */0) {
    var supplementaryFeed = Decco.optionFromJson(feed_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "supplementaryFeed"), null));
    if (supplementaryFeed.TAG === /* Ok */0) {
      var currencies = Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(dict$1, "currencies"), (function (param) {
                  return Decco.arrayFromJson((function (json) {
                                var match = Js_json.classify(json);
                                if (typeof match === "number") {
                                  return Decco.error(undefined, "Not a tuple", json);
                                }
                                if (match.TAG !== /* JSONArray */3) {
                                  return Decco.error(undefined, "Not a tuple", json);
                                }
                                var match$1 = match._0;
                                if (match$1.length !== 2) {
                                  return Decco.error(undefined, "Incorrect cardinality", json);
                                }
                                var v0 = match$1[0];
                                var v1 = match$1[1];
                                var match$2 = Decco.stringFromJson(v0);
                                var match$3 = feed_decode(v1);
                                if (match$2.TAG === /* Ok */0) {
                                  if (match$3.TAG === /* Ok */0) {
                                    return {
                                            TAG: /* Ok */0,
                                            _0: [
                                              match$2._0,
                                              match$3._0
                                            ]
                                          };
                                  }
                                  var e = match$3._0;
                                  return {
                                          TAG: /* Error */1,
                                          _0: {
                                            path: "[1]" + e.path,
                                            message: e.message,
                                            value: e.value
                                          }
                                        };
                                }
                                var e$1 = match$2._0;
                                return {
                                        TAG: /* Error */1,
                                        _0: {
                                          path: "[0]" + e$1.path,
                                          message: e$1.message,
                                          value: e$1.value
                                        }
                                      };
                              }), param);
                })), {
            TAG: /* Ok */0,
            _0: []
          });
      if (currencies.TAG === /* Ok */0) {
        var autoSync = Belt_Option.getWithDefault(Belt_Option.map(Js_dict.get(dict$1, "autoSync"), autoSync_decode), {
              TAG: /* Ok */0,
              _0: /* Hourly */1
            });
        if (autoSync.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    userId: userId._0,
                    supplementaryFeed: supplementaryFeed._0,
                    currencies: currencies._0,
                    autoSync: autoSync._0
                  }
                };
        }
        var e = autoSync._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".autoSync" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = currencies._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".currencies" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = supplementaryFeed._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".supplementaryFeed" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = userId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".userId" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function t_encode$1(v) {
  return Decco.arrayToJson(t_encode, v);
}

function t_decode$1(v) {
  return Decco.arrayFromJson(t_decode, v);
}

var codec = [
  t_encode$1,
  t_decode$1
];

var $$Array = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  codec: codec,
  toJson: t_encode$1,
  fromJson: t_decode$1
};

var codec$1 = [
  t_encode,
  t_decode
];

var toJson = t_encode;

var fromJson = t_decode;

export {
  feed_encode ,
  feed_decode ,
  autoSync_encode ,
  autoSync_decode ,
  t_encode ,
  t_decode ,
  $$Array ,
  codec$1 as codec,
  toJson ,
  fromJson ,
}
/* User-FeedSync Not a pure module */
